(ns manatee.app
  (:require #?@(:cljs [com.smxemail.re-frame-cookie-fx
                       [cljs.reader :refer [read-string]]
                       day8.re-frame.http-fx
                       [manatee.ajax :as ajax]
                       [manatee.ui.view :as ui-view]])
            [clojure.string :as str]
            [kee-frame.core :as kf]
            [manatee.app-db :as db]
            [manatee.auth.handlers :as auth-handlers]
            [manatee.routing :refer [ui-routes]]
            [manatee.routing.fx :as routing-fx]
            [manatee.routing.handlers :as routing]
            [manatee.ui.handlers :as ui-handlers]
            [manatee.user.app-db :as user-db]
            [re-frame.core :as rf]
            [taoensso.timbre :as log]))

#?(:cljs (goog-define version ""))

#?(:cljs (enable-console-print!))

(def login-interceptor
  "Ensure a user is logged in (has a user id in the app-db) to allow navigation to
  any route other than login.

  We achieve this by watching for route change events (from kee-frame) and
  checking that we either have a user-id or the route is equal to login.
  Otherwise we want to terminate the interceptor chain early and navigate to
  login."
  (re-frame.core/->interceptor
   :id :login-interceptor
   :before (fn [{{:keys [db] [event-id event-data] :event} :coeffects :as context}]
             (if (and (not (user-db/get-user-id db))
                      (= :kee-frame.router/route-changed event-id)
                      (not= ::auth-handlers/login (:handler event-data)))
               (do (log/info "Redirecting to login")
                   (-> context
                       (assoc-in [:effects :dispatch] [:navigate-to [::auth-handlers/login]])
                       (assoc :queue [])))
               context))))

(defn event-data->title
  [event-data]
  (let [path-parts (-> (:path event-data)
                       (str/replace "-" " ")
                       (str/split "/"))
        tab (str/replace (name (get-in event-data [:query :tab] "")) "-" " ")]
    (str "Manatee: "
         (->> path-parts
              (remove str/blank?)
              (map str/capitalize)
              (str/join " — "))
         (when-not (str/blank? tab)
           (str " — " (str/capitalize tab))))))

#?(:cljs
   (def title-interceptor
     (re-frame.core/->interceptor
      :id :title-interceptor
      :after (fn [{{[event-id event-data] :event} :coeffects :as context}]
               (when (= :kee-frame.router/route-changed event-id)
                 (let [title (event-data->title event-data)]
                   (when title
                     (set! js/document.title title))))
               context))))

#?(:cljs (defn suppress-ctrl-p
           "Suppress the default action for ctrl-p keydown events.
            In Chrome on Windows, this key chord brings up the Print dialog in
            addition to its effect on the audio player; we would prefer just
            the player effect."
           [event]
           (assert (= "keydown" (.-type event)))
           (when (and (= "p" (.-key event))
                      (.-ctrlKey event)
                      (not (.-altKey event))
                      (not (.-metaKey event))
                      (not (.-shiftKey event)))
             (.preventDefault event)
             (.stopPropagation event))))

(defn init!
  ([] (init! nil))
  ([{:keys [config db] :as opts}]
   (let [config (or config #?(:cljs (read-string js/window.manatee_config)) nil)]
     (log/info "Initializing manatee")
     (routing-fx/register-redirect-to #(init! opts))
     (rf/reg-global-interceptor login-interceptor)
     #?(:cljs (rf/reg-global-interceptor title-interceptor))
     (kf/start! {:router (routing/->BidiBrowserRouter (ui-routes config))
                 :initial-db (or db (db/initial-db config))
                 :root-component #?(:clj nil :cljs [ui-view/app])})
     (rf/dispatch-sync [::ui-handlers/init-app config])
     #?(:cljs (ajax/init-cljs-ajax! config))
     #?(:cljs (.addEventListener js/window "keydown" suppress-ctrl-p)))))
